import { connected } from '@ambiki/impulse';

// Whether Bootstrap's popover plugin is loaded, without querying every [data-toggle="popover"] on the page.
const popoverLoaded = () => typeof $.fn.popover === 'function';

/**
 * Initializes the bootstrap popover component when element is connected to the DOM and disposes it when element is
 * removed from the DOM.
 */
connected('[data-toggle="popover"]', (element) => {
  if (popoverLoaded()) {
    $(element).popover();
  }

  return () => {
    if (popoverLoaded()) {
      $(element).popover('dispose');
    }
  };
});
